import React, { FC } from 'react';
import Button from 'components/commercetools-ui/atoms/button';
import Typography from 'components/commercetools-ui/atoms/typography';
import CloseIcon from 'components/icons/close';
import { CurrencyHelpers } from 'helpers/currencyHelpers';
import useLocale from 'helpers/hooks/useLocale';
import { useCart } from 'frontastic';
import { GiftcardAppliedProps } from '../types';
import PaymentHelper from '../../checkout/components/steps/sections/payment/helper/index';
import { sdk } from 'sdk';
import { Event } from '@commercetools/frontend-sdk';

const AppliedGiftcards: FC<GiftcardAppliedProps> = ({ ...props }) => {
  const { ctLocale: locale } = useLocale();
  const { data, removeGiftcard } = useCart();
  const paymentHelper = PaymentHelper();

  const getPaymentStepIndex = () => {
    return data?.custom?.deliveryOption === 'StoreCollection' ? 2 : 3;
  };

  const onDelete = (giftcard: string | '') => {
    removeGiftcard(giftcard)
      .then(() => {
        const paymentStepIndex = getPaymentStepIndex();
        if (props?.section == 'cost') {
          sdk.trigger(
            new Event({
              eventName: 'removeGiftcardClicked',
              data: { paymentStepIndex: paymentStepIndex },
            }),
          );
        }
      })
      .catch(() => {
        console.log('remove Giftcard Failed');
      });
    paymentHelper.freezeCartForPayment(data);
  };

  return (
    <div>
      {data && data?.payments && data?.payments?.length > 0 && (
        <div className="mt-20">
          <p>Applied gift cards</p>
          {data?.payments?.map(({ giftcardNumber, amountPlanned }) => (
            <div key={giftcardNumber} className="my-10 flex rounded bg-[#f7f8f9] p-14">
              <div className="w-full">
                <Typography className="relative font-light">{giftcardNumber}</Typography>
                <Typography className="relative mt-8 font-medium">
                  {amountPlanned && CurrencyHelpers.formatForCurrency(amountPlanned, locale)}
                </Typography>
              </div>
              <Button variant="ghost" onClick={() => onDelete(giftcardNumber || '')} className="!px-8 !py-0">
                <CloseIcon className="h-10 w-10 cursor-pointer hover:h-12 hover:w-12" />
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AppliedGiftcards;
